<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'

const EntryPoint = defineAsyncComponent(() => import('frontend/EntryPoint.vue'))
const PasswordResetEntryPoint = defineAsyncComponent(() => import('frontend/PasswordResetEntryPoint.vue'))
const PasswordUpdateEntryPoint = defineAsyncComponent(() => import('frontend/PasswordUpdateEntryPoint.vue'))

const route = useRoute()
const isPasswordResetRoute = computed<boolean>(() => {
  return route.path.includes('reset-password')
})
const isPasswordUpdateRoute = computed<boolean>(() => {
  return route.path.includes('update-password')
})
</script>

<template>
  <PasswordResetEntryPoint v-if="isPasswordResetRoute" />
  <PasswordUpdateEntryPoint v-else-if="isPasswordUpdateRoute" />
  <EntryPoint v-else />
</template>
